export default __webpack_public_path__ + "static/media/call_icon_white.0c085b16.svg";